module.exports = __webpack_public_path__ + "79c19e0eb700f12557a7f482f2e9676f.svg";